export default __webpack_public_path__ + "static/media/Homescreen-02.c73ca78d.jpg";